<div class="tas-modal-content instruction-modal">
  <button class="tas-modal-close" (click)="close.emit()">&times;</button>

  <ng-container *ngIf="modalData?.type === 'passport'">
    <h4 class="text-center text-primary fw-normal mb-5 px-2 f-20 f-md-22">
      Recuerda que debes de cargar dos<span class="fw-bold">
        (2) imágenes / documentos del pasaporte</span
      >
    </h4>
    <div
      class="d-flex flex-row justify-content-center align-items-stretch mb-4"
    >
      <div
        class="step-item-container px-1 px-md-3 d-flex flex-column align-items-center text-center"
      >
        <div class="icon-wrapper mb-3 mt-2">
          <div class="instruction-number">1</div>
          <img
            src="https://res.cloudinary.com/pervolare-org/image/upload/v1775490326/TAS/rutt/step2-support/passport_icon_buapj1.svg"
            class="instruction-icon-sharp"
            alt="Icono Pasaporte Personal"
          />
        </div>
        <span class="text-primary f-14 f-md-18 mt-2 fw-bold"
          >Pasaporte con tu<br />información personal</span
        >
      </div>

      <div class="instruction-divider mx-1 mx-md-4"></div>

      <div
        class="step-item-container px-1 px-md-3 d-flex flex-column align-items-center text-center"
      >
        <div class="icon-wrapper mb-3 mt-2">
          <div class="instruction-number">2</div>
          <img
            src="https://res.cloudinary.com/pervolare-org/image/upload/v1775490326/TAS/rutt/step2-support/stamps_icon_wabssi.svg"
            class="instruction-icon-sharp"
            alt="Icono Sellos"
          />
        </div>
        <span class="text-primary f-14 f-md-18 mt-2 fw-bold"
          >Pasaporte con los sellos<br />de tu viaje</span
        >
      </div>
    </div>
    <p class="text-action text-center f-13 f-md-15 mb-2 mt-4 fw-normal px-2">
      <span class="fw-bold text-uppercase">Nota:</span> Si tu pasaporte no tiene
      sellos de viaje envía tus
      <span class="fw-bold"
        >tiquetes aéreos <br class="d-none d-md-block" />
        de ingreso y retorno</span
      >, si aplica.
    </p>
  </ng-container>

  <ng-container *ngIf="modalData?.type === 'expense'">
    <h4 class="text-center text-primary fw-normal mb-5 px-2 f-20 f-md-22">
      <ng-container *ngIf="assistType === 'medical'">
        Carga tu factura y el comprobante del pago que realizaste, ya sea por
        <span class="fw-bold text-primary">consulta médica y/o medicamentos.</span>
      </ng-container>
      <ng-container *ngIf="assistType === 'travel'">
        <span class="fw-bold text-primary"
          >Adjunta las facturas y el comprobante de pago</span
        >
        correspondientes a los gastos realizados, como hotel, transporte,
        artículos de primera necesidad u otros, según tu caso.
      </ng-container>
    </h4>
    <div
      class="d-flex flex-row justify-content-center align-items-stretch mb-4"
    >
      <div
        class="step-item-container px-1 px-md-4 d-flex flex-column align-items-center text-center"
      >
        <div class="icon-wrapper mb-3 mt-2">
          <div class="instruction-number">1</div>
          <img
            src="https://res.cloudinary.com/pervolare-org/image/upload/v1775490326/TAS/rutt/step2-support/factura_jo32nc.svg"
            class="instruction-icon-sharp factura-icon"
            alt="Icono Factura"
          />
        </div>
        <span class="text-primary fw-bold f-14 f-md-18 mt-2">Factura</span>
      </div>

      <div class="instruction-divider mx-1 mx-md-4"></div>

      <div
        class="step-item-container px-1 px-md-4 d-flex flex-column align-items-center text-center"
      >
        <div class="icon-wrapper mb-3 mt-2">
          <div class="instruction-number">2</div>
          <img
            src="https://res.cloudinary.com/pervolare-org/image/upload/v1775490326/TAS/rutt/step2-support/comprobante_pago_frcktc.svg"
            class="instruction-icon-sharp comprobante-icon"
            alt="Icono Comprobante"
          />
        </div>
        <span class="text-primary fw-bold f-14 f-md-18 mt-2"
          >Comprobante de pago</span
        >
      </div>
    </div>
    <p class="text-dark text-center f-14 f-md-16 mb-2 mt-4 fw-normal px-2">
      Es necesario que los valores correspondientes<br /><span class="fw-bold"
        >se vean con total claridad.</span
      >
    </p>
  </ng-container>

  <ng-container *ngIf="modalData?.type === 'prescription'">
    <h4 class="text-center text-primary fw-normal mb-5 px-2 f-20 f-md-22">
      Carga tu <span class="fw-bold">receta médica</span> para solicitar el
      reembolso.
    </h4>
    <div class="d-flex flex-column align-items-center text-center mb-4 mt-2">
      <div
        class="step-item-container w-100 px-md-4 d-flex flex-column align-items-center text-center"
      >
        <div class="icon-wrapper mb-3 mt-2">
          <div class="instruction-number">1</div>
          <img
            src="https://res.cloudinary.com/pervolare-org/image/upload/v1775490326/TAS/rutt/step2-support/receta_mg1pzd.svg"
            class="instruction-icon-sharp receta-icon"
            alt="Icono Receta Médica"
          />
        </div>
        <span class="text-primary fw-bold f-14 f-md-18 d-block mt-3 mb-4">
          Receta con medicamentos
        </span>
      </div>

      <p class="text-dark text-center f-14 f-md-16 px-3 px-md-5 mb-2 fw-normal">
        Carga las recetas médicas con las que cuentes,
        <span class="fw-bold">deben ser claras y legibles</span> para poder
        identificar los medicamentos recetados.
      </p>
    </div>
  </ng-container>

  <ng-container *ngIf="modalData?.type === 'specialSupport'">
    <h4 class="text-center text-primary fw-normal mb-5 px-2 f-20 f-md-22">
      <ng-container *ngIf="assistType === 'medical'">
        Carga tu <span class="fw-bold text-primary">informe médico</span> en el
        sistema.
      </ng-container>
      <ng-container *ngIf="assistType === 'travel'">
        Adjunta los soportes que respalden tu solicitud, como
        <span class="fw-bold text-primary"
          >carta de la aerolínea, denuncia de pérdida, entre otros.</span
        >
      </ng-container>
    </h4>
    <div class="d-flex flex-column align-items-center text-center mb-4 mt-2">
      <div
        class="step-item-container w-100 px-md-4 d-flex flex-column align-items-center text-center"
      >
        <div class="icon-wrapper mb-3 mt-2">
          <div class="instruction-number">1</div>
          <img
            src="https://res.cloudinary.com/pervolare-org/image/upload/v1775490326/TAS/rutt/step2-support/receta_mg1pzd.svg"
            class="instruction-icon-sharp"
            alt="Icono Soporte Especial"
          />
        </div>
        <span class="text-primary fw-bold f-14 f-md-18 d-block mt-3 mb-4">
          Informe de atención
        </span>
      </div>

      <p class="text-dark text-center f-14 f-md-16 px-3 px-md-5 mb-2 fw-normal">
        Recuerda que la imagen debe ser
        <span class="fw-bold"
          >clara y legible para brindarte una solución oportuna.</span
        >
      </p>
      <p
        class="text-action text-center f-13 f-md-15 mb-2 mt-2 px-2 px-md-5 fw-normal"
        *ngIf="assistType === 'medical'"
      >
        <span class="fw-bold text-uppercase">Nota:</span> Es necesario incluir
        el detalle completo de la atención médica recibida.
      </p>
    </div>
  </ng-container>

  <ng-container *ngIf="modalData?.type === 'other'">
    <h4 class="text-center text-primary fw-normal mb-5 px-2 f-20 f-md-22">
      Carga documentos adicionales como:
      <span class="fw-bold">resultados médicos, órdenes de exámenes, etc.</span>
    </h4>
    <div class="d-flex flex-column align-items-center text-center mb-4 mt-2">
      <div
        class="step-item-container w-100 px-md-4 d-flex flex-column align-items-center text-center"
      >
        <div class="icon-wrapper mb-3 mt-2">
          <div class="instruction-number">1</div>
          <img
            src="https://res.cloudinary.com/pervolare-org/image/upload/v1775490326/TAS/rutt/step2-support/other_docs_facepw.svg"
            class="instruction-icon-sharp others-icon"
            alt="Icono Documentos"
          />
        </div>
        <span class="text-primary fw-bold f-14 f-md-18 d-block mt-3 mb-4">
          Máximo 5 páginas
        </span>
      </div>

      <p class="text-dark text-center f-14 f-md-16 px-3 px-md-5 mb-3 fw-normal">
        Recuerda que deben ser
        <span class="fw-bold">claros y completamente legibles.</span>
      </p>
      <p
        class="text-action text-center f-13 f-md-15 mb-2 px-2 px-md-5 fw-normal"
      >
        <span class="fw-bold text-uppercase">Nota:</span> Carga máximo 5
        páginas, si tu documento supera esta cantidad comprímelo en formato
        <span class="fw-bold">ZIP o RAR antes de subirlo.</span>
      </p>
    </div>
  </ng-container>

  <div class="text-center mt-4">
    <button class="btn btn-action fw-bold" (click)="proceed.emit()">
      Ok, entendido
    </button>
  </div>
</div>